/**
 * This is only exported to be covered by tests
 */
export const getQueryParamsFromHref = (href: string) => {
    const [url, params] = href.split('?');
    return [url, new URLSearchParams(params)] as const;
};
